import { Modal } from '../../modules/modal.js';

window.app = window.app || {};
app.ui = app.ui || {};


app.ui.modal = {
    init: () => {
        const blacklist = ['#navigation', '#legalModal'];
        document.querySelectorAll('dialog').forEach(item => {
            if (blacklist.some(selector => item.matches(selector))) {
                return;
            }
            app.ui.modal.create(item);
        });
    },
    create: (id, settings = {}) => {
        new Modal({
            ...settings,
            modal: id,
            on: {
                beforeOpen: () => {
                    app.site.controls.fullstop();
                },
                close: () => {
                    if (typeof MsCrmMkt !== 'undefined' && 'MsCrmFormLoader' in MsCrmMkt) {
                        delete MsCrmMkt.MsCrmFormLoader;
                    }
                }
            }
        });
    },
    open: (id) => {
        window.Modal.open(document.getElementById(id), true);
    }
};
